import _get from 'lodash/get';
import { HD, IMAGE_FIT_SCALE_CROP, IMAGE_QUALITY, DEFAULT_IMAGE_FORMAT } from '@bedrock-rdk/constants';
import config from '@bedrock-rdk/config';
import { imageService } from '@bedrock/fido-sdk';
import { getScreenSize, SCREEN_WIDTH, SCREEN_HEIGHT } from '../tornado/utils/sizes';
import imageHD from '../../images/customer/default/landing-background-HD.jpg';
import imageFHD from '../../images/customer/default/landing-background-FULL_HD.jpg';
import { getFullPath } from '../settings/app.settings';

export * from './customer/default/landing.utils';

export const getBackgroundUrl = screenSize => {
  const resolution = screenSize || getScreenSize();

  const imageId = _get(config, 'customMedia.landingImage');
  if (imageId) {
    return imageService.getUrl(imageId, SCREEN_WIDTH[screenSize], SCREEN_HEIGHT[screenSize], {
      fit: IMAGE_FIT_SCALE_CROP,
      quality: IMAGE_QUALITY,
      format: DEFAULT_IMAGE_FORMAT,
      interlace: 1,
    });
  }

  return getFullPath(resolution === HD ? imageHD : imageFHD);
};
